import PropTypes from "prop-types";
import * as React from "react";
import TreeItemStore from "data/TreeItemStore";
import TreeItemActions from "data/TreeItemActions";

import ValidationTreeItem from "./ValidationTreeItem";
import { itemType } from "../types";
import useFluxStore from "@armus/use-flux-store";

class PanelBody extends React.Component {
    render() {
        const {
            item,
            onExpandAll,
            onCollapseAll,
            collapsedAll,
            expandedAll,
        } = this.props;
        const extendedItem = {
            ...item,
            collapsedAll,
            expandedAll,
        };

        return (<div className="panel-body">
            <div className="validationtree">
                <div className="actions">
                    <button type="button" className="btn btn-expand-all" onClick={onExpandAll}>
                        <span/>
                    </button>
                    <span>&nbsp;</span>
                    <button type="button" className="btn btn-collapse-all" onClick={onCollapseAll}>
                        <span/>
                    </button>
                </div>
                <ValidationTreeItem
                    nodeKey=""
                    isKeyExpanded={this.props.isKeyExpanded}
                    onChildCollapseOrExpand={this.props.onChildCollapseOrExpand}
                    expanded={this.props.isKeyExpanded("")}
                    item={extendedItem}
                />
            </div>
        </div>);
    }
}

PanelBody.propTypes = {
    collapsedAll: PropTypes.bool.isRequired,
    expandedAll: PropTypes.bool.isRequired,
    item: itemType.isRequired,
    onChildCollapseOrExpand: PropTypes.func.isRequired,
    onCollapseAll: PropTypes.func.isRequired,
    onExpandAll: PropTypes.func.isRequired,
    isKeyExpanded: PropTypes.func.isRequired,
};

export const PanelBodyContainer = props => {
    const { ctx } = props;
    const state = useFluxStore(() => ({
        collapsedAll: !TreeItemStore.isExpandAll(ctx),
        expandedAll: TreeItemStore.isExpandAll(ctx),
        onChildCollapseOrExpand: TreeItemActions.childCollapseOrExpand.bind(
            undefined,
            ctx,
        ),
        onCollapseAll: TreeItemActions.collapseAll.bind(undefined, ctx),
        onExpandAll: TreeItemActions.expandAll.bind(undefined, ctx),
        isKeyExpanded: TreeItemStore.getExpandedTest(ctx),
    }), [
        TreeItemStore,
    ], [ctx]);
    return <PanelBody {...props} {...state} />;
};

PanelBodyContainer.propTypes = {
    ctx: PropTypes.string.isRequired,
    item: itemType.isRequired,
};



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/validationtree/components/PanelBodyPOC.js